import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { NgBusyModule } from 'ng-busy';
import { TranslateModule } from '@ngx-translate/core';
import { DropzoneModule } from 'ngx-dropzone-wrapper';
import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';

import { NgCakeItEasyUtilsModule } from '@cakeiteasy/web-utils';
import { CakeItEasyWebUiModule, ImageCropperExtraModule, UiChooseMotiveModalComponent, UiFullSizeImageComponent } from '@cakeiteasy/web-ui';

import { SharedModule } from '../shared/shared.module';

import { BuildSectionComponent } from './components/build-section/build-section.component';
import { CakeBuilderComponent } from './cake-builder.component';
import { CakeSizesSectionComponent } from './components/cake-sizes-section/cake-sizes-section.component';
import { CakeTextSectionComponent } from './components/cake-text-section/cake-text-section.component';
import { CakeVariantsSectionComponent } from './components/cake-variants-section/cake-variants-section.component';
import { CakeMultipleVariantsSectionComponent } from './components/cake-multiple-variants-section/cake-multiple-variants-section.component';
import { CakeInfoComponent } from './components/cake-info/cake-info.component';
import { CakeExtraProductsSectionComponent } from './components/cake-extra-products-section/cake-extra-products-section.component';
import { CakeTotalComponent } from './components/cake-total/cake-total.component';
import { CakeMotiveSectionComponent } from './components/cake-motive-section/cake-motive-section.component';
import { GreetingCardSectionComponent } from './components/greeting-card-section/greeting-card-section.component';
import { CheckDateSectionComponent } from './components/check-date-section/check-date-section.component';
import { CakeQuestionSectionComponent } from './components/cake-question-section/cake-question-section.component';
import { YesNoAddOnSectionComponent } from './components/yes-no-add-on-section/yes-no-add-on-section.component';
import { CakeInfoTabsComponent } from './components/cake-info/cake-info-tabs/cake-info-tabs.component';
import { CakeInfoPriceComponent } from './components/cake-info/cake-info-price/cake-info-price.component';
import { ProductDepositSectionComponent } from './components/product-deposit-section/product-deposit-section.component';
import { UpsellProductsSectionComponent } from './components/upsell-products-section/upsell-products-section.component';
import { SubmitButtonsSectionComponent } from './components/submit-buttons-section/submit-buttons-section.component';
import { CakeCounterComponent } from './components/cake-counter/cake-counter.component';
import { CakeTotalStkComponent } from './components/cake-total-stk/cake-total-stk.component';
import { CakePriceTotalComponent } from './components/cake-price-total/cake-price-total.component';
import { UpsellMinQuantityComponent } from './components/upsell-min-quantity/upsell-min-quantity.component';
import { CommonAddonsSectionComponent } from './components/common-addons-section/common-addons-section.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CakeItEasyWebUiModule,
    NgCakeItEasyUtilsModule,
    TranslateModule.forChild(),
    NgBusyModule,
    DropzoneModule,
    ScrollToModule,
    ImageCropperExtraModule,
    SharedModule,
    CakeItEasyWebUiModule,
    CakeInfoPriceComponent,
  ],
  exports: [
    CakeBuilderComponent,
    UpsellProductsSectionComponent,
  ],
  declarations: [
    BuildSectionComponent,
    CheckDateSectionComponent,
    CakeBuilderComponent,
    CakeSizesSectionComponent,
    CakeTextSectionComponent,
    CakeQuestionSectionComponent,
    CakeVariantsSectionComponent,
    CakeMultipleVariantsSectionComponent,
    CakeInfoComponent,
    CakeExtraProductsSectionComponent,
    CakeTotalComponent,
    CakeMotiveSectionComponent,
    GreetingCardSectionComponent,
    YesNoAddOnSectionComponent,
    CakeInfoTabsComponent,
    ProductDepositSectionComponent,
    UpsellProductsSectionComponent,
    SubmitButtonsSectionComponent,
    CakeCounterComponent,
    CakeTotalStkComponent,
    CakePriceTotalComponent,
    UpsellMinQuantityComponent,
    CommonAddonsSectionComponent,
  ]
})
export class CakeBuilderModule {
}
